export const MAIN_ROUTES = {
  ABOUT_US: "/about-us",
  ACCEPTED_USE_POLICY: "/accepted-use-policy",
  APPLICATION_SERVICES: "/application-services",
  BAREMETAL: "/baremetal",
  BOOK_A_CONSULTATION: "/book-a-consultation",
  BANDWIDTH_BACKUP_OVERAGES: "/bandwidth-backup-policies",
  CATALOG: "/catalog",
  CLOUD_SERVICES: "/cloud-services",
  CODE_OF_CONDUCT: "/code-of-conduct-ba",
  CYBER_SECURITY: "/cyber-security",
  DATA_CENTER: "/data-centers",
  DEDICATED_SERVICE_LEVEL_GUARANTEE: "/dedicated-server-level-guarantee",
  CLOUD_SERVICE_LEVEL_AGREEMENT: "/cloud-service-level-agreement",
  CLOUD_TERMS_OF_SERVICE: "/terms-of-service",
  DMCA: "/dmca",
  HOME: "/",
  HOSTING_SERVICES_AGREEMENT: "/hosting-master-services-agreement",
  HOSTING_COLOCATIONS_ERVICES_AGREEMENT: "/hosting-colocation-services-agreement",
  COLOCATION_POLICIES_AND_REGULATIONS: "/hosting-colocation-policies-and-regulations",
  IAAS: "/iaas",
  NETWORK_SERVICES: "/network-services",
  SERVICE_GUARANTEE: "/service-guarantee",
};

export const CLOUD_SERVICES_ROUTES = {
  CERTIFICATION_LABS: "/certification-labs",
  EMULATE_SIMULATE_REAL: "/emulate-simulate-real",
  ENCRYPTED_STORAGE_CLUSTERS: "/encrypted-storage-clusters",
  LAB_AS_A_SERVICE: "/lab-as-a-service",
  MANAGED_UNMANAGED_CO_MANAGED: "/managed-unmanaged-co-managed",
  NETWORK_AUTOMATION: "/network-automation",
  NETWORK_DIGITAL_TWINS: "/network-digital-twins",
  OEM_CONVERGED_ARCHITECTURE: "/oem-converged-architecture",
  OPEN_STACK_CLOUD: "/open-stack-cloud",
  PERFORMANCE_LABS: "/performance-labs",
  PHYSICAL_LABS: "/physical-labs",
  POC_AS_A_SERVICE: "/poc-as-a-service",
  PRIVATE_K8_CLUSTERS: "/private-k8-clusters",
  VIRTUOZZO_PAAS: "/virtuozzo-paas",
  VMWARE_CLOUD: "/vmware-cloud",
  ZADARA_CLOUD: "/zadara-cloud",
  MIGRATE_TO_MOST: "/migrate-to-most",
};

export const IAAS_ROUTES = {
  BAREMETAL: "/bare-metal",
  DEDICATED_SERVER: "/dedicated-servers",
  GPU_HOSTING: "/gpu-hosting",
  VDI: "/vdi",
  BLOCK_AND_S3_STORAGE: "/block-and-s3-storage",
  DISASTER_RECOVERY: "/disaster-recovery",
};

export const CYBER_SECURITY_ROUTES = {
  CLOUD_SECURITY_SASE: "/cloud-security-sase",
  COMPLIANCE_MANAGEMENT: "/compliance-management-sec-ops",
  EDR_MDR_XDR: "/edr-mdr-xdr",
  RANSOMWARE_DDOS_PROTECTION: "/ransomware-ddos-protection",
  VULNERABILITY_PATCH_MANAGEMENT: "/vulnerability-patch-management",
  ZTNA_VPN_EDGE_FIREWALL_SASE: "/ztna-vpn-edge-firewall-sase",
};

export const NETWORK_SERVICES_ROUTES = {
  COLOCATION: "/colocation",
  DESIGN_AND_DEPLOYMENT: "/design-and-deployment",
  NETWORK_OBSERVABILITY_AND_NMS: "/network-observability-and-nms",
  NOC_SOC_HELPDESK: "/noc-soc-helpdesk",
  SDN_SD_WAN_WIRED_WIRELESS: "/sdn-sd-wan-wired-wireless",
  VMWARE_MIGRATION: "/vmware-migrate",
  MIGRATE_TO_ZADARA: "/migrate-to-zadara",
  WIRED_AND_WIRELESS_NETWORKS: "/wired-and-wireless-networks",
};

export const APPLICATION_SERVICES_ROUTES = {
  HOSTED_NOM: "/hosted-nom",
  HOSTED_ELASTIC: "/hosted-elastic",
  HOSTED_GRAFANA: "/hosted-grafana",
  HOSTED_CMS: "/hosted-cms",
  HOSTED_NETBOX: "/hosted-netbox",
  HOSTED_RANCHER: "/hosted-rancher",
  INUVIKA_VDI: "/inuvika-vdi",
};
